import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogTitle from "@mui/material/DialogTitle/DialogTitle"
import React from "react"
import { importJob } from "../../../JobSearchModal/JobsTable"

const name = "GoBackDialog"

interface GoBackDialogProps {
    setOpen: any
    jobId: number
    open: boolean
}

const GoBackDialog: React.FC<GoBackDialogProps> = ({ setOpen, open, jobId }) => {
    const handleClose = React.useCallback(() => {
        setOpen(false);
    }, [setOpen]);

    const handleImport = React.useCallback(() => {
        importJob(jobId);
        handleClose()
    }, [handleClose, jobId]);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{"Import stored Job data?"}</DialogTitle>
            <DialogContent dividers>
                <DialogContentText id="alert-dialog-description">
                    Job recall: are you sure you want to go back to previous job?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleImport} color="primary">
                    Import Go Back
                </Button>
                <Button onClick={handleClose} color="primary" autoFocus>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    )
}

GoBackDialog.displayName = name

export default React.memo(GoBackDialog)